var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-container"},[(_vm.loading)?_c('div',[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"loading"})]):_c('div',{staticClass:"empty-image"},[_c('svg-icon',{attrs:{"iconClass":"empty"}})],1),_c('p',{staticClass:"empty-description"},[_vm._v(_vm._s(_vm.textTips))])])
}
var staticRenderFns = []

export { render, staticRenderFns }